/* RecommendedPanel.tsx generated by @compiled/babel-plugin v3.0.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDyzSk%7Bborder-radius%3Avar(--ds-radius-xlarge%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4c065UNHnM%7Bpadding-block%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Y7lL45zaO%7Bpadding-inline%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXrunmFW%7Bbackground-color%3Avar(--ds-surface-sunken%2C%23f8f8f8)%7D");
import React from 'react';
import { Box } from '@atlaskit/primitives/compiled';
const styles = {
  panel: "_0bjKvDyzSk _4c065UNHnM _2Y7lL45zaO _0KLXrunmFW"
};
export const RecommendedPanel = ({
  children,
  testId
}: {
  children: React.ReactNode;
  testId?: string;
}): React.JSX.Element => <Box xcss={styles.panel} testId={testId}>
		{children}
	</Box>;